import { AdminAppState } from '../../state';
import { getSiteViewportState } from './get-site-viewport-state';

export const getSiteViewportSelectorVisible = (state: AdminAppState): boolean =>
  getSiteViewportState(state).selectorVisible;
